/**
 * Returns true if the current device is a mobile/touch device.
 * Uses userAgent as primary signal; falls back to touchpoints + screen width.
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined') return false;
  const mobileUA = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  if (mobileUA) return true;
  return navigator.maxTouchPoints > 0 && window.matchMedia('(max-width: 768px)').matches;
}
